import { Loader2, MapPin } from 'lucide-react';

import {
  Command,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import { cn } from '@/lib/utils';

type Props = {
  value: string | null;
  locations: string[];
  searchQuery: string;
  isPending: boolean;
  isSearching: boolean;
  error?: string;
  onSearch: (value: string) => void;
  onSelect: (value: string) => void;
  onClear: () => void;
};

export const LocationComboBox = ({
  value,
  locations,
  searchQuery,
  isPending,
  isSearching,
  error,
  onSearch,
  onSelect,
}: Props) => (
  <Command shouldFilter={false}>
    <div className='relative'>
      <CommandInput
        className='pr-6'
        placeholder='Search location...'
        value={searchQuery}
        onValueChange={onSearch}
      />
      {(isSearching || isPending) && (
        <div className='absolute right-3 top-1/2 -translate-y-1/2'>
          <Loader2 className='size-4 animate-spin' />
        </div>
      )}
    </div>
    <CommandList>
      <CommandGroup>
        <CommandItem value='any' onSelect={() => onSelect('any')}>
          <MapPin
            className={cn(
              'mr-2 size-4',
              value === 'any' ? 'text-brand-base opacity-100' : 'opacity-50',
            )}
          />
          Any location
        </CommandItem>
        {locations.map((loc) => (
          <CommandItem key={loc} value={loc} onSelect={() => onSelect(loc)}>
            <MapPin
              className={cn(
                'mr-2 size-4',
                value === loc ? 'text-brand-base opacity-100' : 'opacity-50',
              )}
            />
            {loc}
          </CommandItem>
        ))}
        {!isSearching && !isPending && locations.length === 0 && (
          <CommandItem disabled>
            <span className='mr-2 inline-block size-4' />
            {error
              ? 'Unable to load locations'
              : searchQuery.length < 2
                ? 'Type at least 2 characters'
                : 'No locations found'}
          </CommandItem>
        )}
      </CommandGroup>
    </CommandList>
  </Command>
);
